interface TrimStringToLengthParams {
  text: string;
  length?: number;
}

/**
 * Trims a string to a specified length and appends "..." if the string is longer than the specified length.
 *
 * @param {string} text - The string to be trimmed.
 * @param {number} length - The maximum length of the string. Defaults to 100.
 * @returns {string} The trimmed string, or the original string if it's shorter than the specified length.
 */
export const trimStringToLength = ({ text, length = 100 }: TrimStringToLengthParams): string => {
  if (text.length > length) {
    return `${text.substring(0, length)}...`;
  }
  return text;
};
